module.exports = __webpack_public_path__ + "img/aproveitamento.2b14127b.png";